export function aspectRatioToPercentage(aspectRatio = '1 / 1'): string {
  const [w, h] = aspectRatio.split('/').map((s) => +s.trim());
  return `${(100 * h) / w}%`;
}
